// Copyright 2025, Imprivata, Inc.  All rights reserved.

import { useState } from 'react';

import ImprListView from '../users/impr-list-view/ImprListView';
import IdentityUsersEmpty from './empty/IdentityUsersEmpty';

const IdentityUsers = () => {
  const [, setSearchVal] = useState<string>('');

  const handleSearch = () => {
    console.log('searching data');
  };

  const handleSearchChange = (searchValue: string) => {
    setSearchVal(searchValue);
    console.log('Search value:', searchValue);
  };

  return (
    <div>
      <ImprListView
        enableMenu={true}
        dataSource={[]} // replace with actual data source
        customEmptyListNode={<IdentityUsersEmpty />}
        sortLabel={'All users (by name)'}
        handleSearch={handleSearch}
        onSearchChange={handleSearchChange}
      />
    </div>
  );
};

export default IdentityUsers;
